import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/token/', { username, password });
    return response.data;
  },

  register: async (data) => {
    const response = await api.post('/auth/auth/register/', data);
    return response.data;
  },

  createUser: async (data) => {
    const response = await api.post('/auth/auth/create_user/', data);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/auth/me/');
    return response.data;
  },

  updateProfile: async (data) => {
    const response = await api.put('/auth/auth/me/', data);
    return response.data;
  },

  listFirms: async () => {
    const response = await api.get('/auth/firms/');
    return response.data;
  },

  createFirm: async (data) => {
    const response = await api.post('/auth/firms/create/', data);
    return response.data;
  },

  logout: async () => {
    await api.post('/auth/auth/logout/');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('company_id');
    localStorage.removeItem('financial_year_id');
  },

  refreshToken: async (refreshToken) => {
    const response = await api.post('/auth/token/refresh/', { refresh: refreshToken });
    return response.data;
  },
};
